import React, { FC, useEffect, useState } from "react";
import Head from "next/head";
import {
	useUnityCommunicationSubscription,
	useGetIslandsMutation,
} from "../../lib/graphql/game.graphql";
import { useRouter } from "next/router";
import Unity, { UnityContext } from "react-unity-webgl";
import styles from "./game.module.scss";
import { MdFullscreen } from "react-icons/md";
import { IoMdArrowBack } from "react-icons/io";
import ProgressBar from "@ramonak/react-progress-bar";
import { GetAuth } from "../../lib/auth";
import Layout from "../../components/layout";
import { Center, Container } from "../../components/basic";
import { Background } from "../background";
import { Pages } from "../../lib/pages";

const unityContext = new UnityContext({
	loaderUrl: "/Unity/Build.loader.js",
	dataUrl: "/Unity/Build.data",
	frameworkUrl: "/Unity/Build.framework.js",
	codeUrl: "/Unity/Build.wasm",
});

const Game: FC = () => {
	const router = useRouter();
	const { data, error } = useUnityCommunicationSubscription({
		variables: {
			jwt: typeof window === "undefined" ? "" : GetAuth(),
		},
	});
	const [getIslands] = useGetIslandsMutation();
	const [loading, setLoading] = useState(0);

	useEffect(() => {
		unityContext.on("progress", (progress) => {
			setLoading(Math.round(progress * 100));
		});
		unityContext.on("GetIslands", async () => {
			await getIslands();
		});
	}, [getIslands]);

	useEffect(() => {
		if (data) {
			console.log(data.unityCommunication);
			unityContext.send(
				"GameController",
				data.unityCommunication.code,
				data.unityCommunication.message
			);
		}
	}, [data]);

	const isLoaded = () => loading === 100;

	const Fullscreen = () => {
		unityContext.setFullscreen(true);
	};

	if (error) {
		router.push(Pages.Profile);
		return (
			<Layout title="Chyba">
				<Container>
					<Center>
						<h1>Chyba</h1>
					</Center>
				</Container>
			</Layout>
		);
	}
	return (
		<>
			<Head>
				<title>Codeventure</title>
			</Head>
			{!isLoaded() ? (
				<Background>
					<div className={styles.horizontalCenter}>
						<div className={styles.loading}>
							<ProgressBar completed={loading} transitionDuration="0.1s" />
						</div>
					</div>
				</Background>
			) : (
				<>
					<div className={styles.fullscreen} onClick={Fullscreen}>
						<MdFullscreen width={20} height={20} />
					</div>

					<div className={styles.goback} onClick={() => router.push(Pages.Index)}>
						<IoMdArrowBack width={20} height={20} />
					</div>
				</>
			)}
			<Unity
				unityContext={unityContext}
				className={isLoaded() ? styles.unity : styles.unityInvisible}
			/>
		</>
	);
};

export default Game;
